var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.84649C3 5.29459 3.34947 4.8046 3.86759 4.63008L11.3675 2.10372C11.7781 1.96543 12.2219 1.96543 12.6325 2.10372L20.1324 4.63008C20.6505 4.80461 21 5.29459 21 5.84649V9.34829C21 14.9048 17.6245 19.8913 12.4999 21.9052C12.1784 22.0316 11.8216 22.0316 11.5001 21.9052C6.37552 19.8913 3 14.9048 3 9.34829V5.84649Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.82dc7bac722b165ad8d7fd2d5ab5452e.svg";
export { ForwardRef as ReactComponent };